/**
 * @title cart.js: Feature level module
 * @description The module used for 'cart'
 * feature which encapsulates the cart page.
 */
define(['orderSummary', 'orderSummaryCart', 'orderitems','eddservice', 'shippingcosts', 'address', 'addressDisplay', 'addressForm', 'addressVerification', 'checkout_helper', 'scheduledDeliverable', 'timeoutModal', 'deliverymethodinfomodal'],
  function(orderSummary, orderSummaryCart, orderitems, eddservice, shippingcosts, address, addressDisplay, addressForm, addressVerification, checkout_helper, scheduledDeliverable, timeoutModal, deliverymethodinfomodal) {
    /**
    * [init description]
    * @return {void} [description]
    */
    function init() {
      $('[name=add-membership-number]').mask('#');
      checkout_helper.display_error_after_redirect();
      orderitems.init();
      COSTCO.deliverymethodinfomodal.init();
      if(typeof $('#live-tickets-review') !== 'undefined' && $('#live-tickets-review').length === 0) {
        shippingcosts.init();
      }
      address.bindEvents();
      scheduledDeliverable.init();

      if (checkout_helper.isCartPage() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
        orderSummaryCart.init();
      }  
      
      if(!$('#cart').length > 0) {
        //The contract global error div will be display only if existing order level errors are not displayed
        if(!$('.order-error').is(':visible')){
          $('#contractErrContainer').removeClass('hidden');
        }
        var invokeOrderPrepare = $("#ShopCartForm input[name='invokeOrderPrepare']").val();
        console.log("invokeOrderPrepare :: " +invokeOrderPrepare);
        if(typeof invokeOrderPrepare !== 'undefined' && invokeOrderPrepare === 'true'){
          orderitems.order_prepare();
          $('#ShopCartForm input[name=invokeOrderPrepare]').val(false);
        }
      }

      $('body').unbind("count.delivery.inst.characters").bind("count.delivery.inst.characters", function(event, additionalParam) {
        let suffix = additionalParam !== null ? ('-' + additionalParam) : '';
        let label = '#delivery-message-count' + suffix;
        let textArea = '#deliveryInstructions' + suffix;
        if ($(label).length > 0 && $(textArea).length > 0 ) {
          COSTCO.Checkout.character_count($(label), $(textArea));
        }
      });
      $('.unit-content').unbind().on('click', function(e) {
        $(this).find('input').focus();
      });
      if ($(window).width() <= 768) {
        if ($('#checkout-button-wrapper').is(":visible")) {
          $('#footer-bottom').addClass('sticky-footer');
        }
      }
      $(window).resize(function () {
        if ($(window).width() <= 768) {
          if ($('#checkout-button-wrapper').is(":visible")) {
            $('#footer-bottom').addClass('sticky-footer');
          }
        }
        else {
          $('#footer-bottom').removeClass('sticky-footer');
        }
      });
      COSTCO.timeoutModal.init();
      //SFSTRY0015381-print warning nofitication if there is mismatch between zip codes in header and shipping address
      if (COSTCO.util.isBDStore() && COSTCO.util.isUserLoggedIn()) {
        let zipCodeFromShippingAddress = (COSTCO.ShippingCosts.getAddress() !== null && typeof COSTCO.ShippingCosts.getAddress().PostalCode !== 'undefined') ? COSTCO.ShippingCosts.getAddress().PostalCode : '';
        let zipCodeFromHeader = (COSTCO.util.getBDZipCookie() !== null && typeof  COSTCO.util.getBDZipCookie().zipCode !== 'undefined') ?  COSTCO.util.getBDZipCookie().zipCode : '';
        if (zipCodeFromShippingAddress !== '' && zipCodeFromHeader !== '' && !(zipCodeFromHeader.includes(zipCodeFromShippingAddress) || zipCodeFromShippingAddress.includes(zipCodeFromHeader))) {
          $('.zip-mismatch-message').removeClass('hidden');
          digitalDataEvents.push( {uimsg:"Cart | Price, Availability, Fees | Based on the Delivery Address"});
        }
      }
    }
    

    if (typeof window.COSTCO == 'undefined') {
      window.COSTCO = {};
    }
    if (typeof window.COSTCO.Global == 'undefined') {
      document.addEventListener('CostcoGlobalLoaded', init, false);
    } else {
      init();
    }
  });



// WEBPACK FOOTER //
// ./js/cart/cart.js